import axios from "axios";
import MockAdapter from "axios-mock-adapter";
import mockData from "../../assets/data/result-mock-data.json";

export function setupMock() {
  const mock = new MockAdapter(axios);

  mock.onGet("/api/mock").reply(200, mockData);

  mock
    .onPost("/api/mock-feedback", {
      params: { email: "a@a.a", attachCalculation: false, feedback: "asd" },
    })
    .reply(201, {
      message: "Feedback submitted successfully",
    })
    .onPost("/api/mock-feedback", {
      params: { email: "a@a.a", attachCalculation: false, feedback: "err" },
    })
    .networkError();

  // Pass through any requests that are not handled by the mock
  mock.onAny().passThrough();
}
